// extracted by mini-css-extract-plugin
export default {"logoBlock":"DSznIpR6cz61Y1HGDSZe","notFoundHeading":"Y6EukJfornRvbe2JwdcD","notFoundMessage":"NKR_XxpF__4u3OuYlKdS"};